// import React, { useEffect, useState } from "react";
// //import { getApi } from "../../../api/api_instance"; // Adjust path if needed
// //import { API_URLS } from "../../../api/apiUrls";     // Make sure this contains EMP_USER_GET
// import { getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// const UserDetails = ({ onUserDataReceived }) => {
//   const [userData, setUserData] = useState({});
//   const token = useSelector((state) => state.auth.authToken);
//   const location = useLocation();
//   const { userId } = location.state || {}; // fallback if state is undefined
//   const user = useSelector((state) => state.auth.user);

//   const [basicInformation, setBasicInformation] = useState({
//     name: "",
//     username: "",
//     userId: "",
//     description: "",
//     organizationDetails: "",
//   });

//   const fetchDetails = async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_PROJECTS_BY_USER_ID(userId), // use ID from state
//         token: token,
//       });
//       if (response.success) {
//         const data = response.data[0];
//         onUserDataReceived?.(data);
//         setUserData(data);
//         setBasicInformation({
//           name: data.name,
//           username: data.email,
//           userId: data.employee_id,
//           location: data.location,
//           contact_no: data.contact_no,
//         });
//       }
//     } catch (error) {
//       console.log("Unable to get user details", error);
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       fetchDetails();
//     }
//     if (user) {
//       setBasicInformation({
//         name: user.name,
//         username: user.email,
//         userId: user.employee_id,
//         description: "",
//         organizationDetails: "",
//       });
//     }
//   }, [token]);

//   return (
//     <div className="mb-7 mt-2 bg-[#fff]">
//       <div className="flex justify-between mx-16">
//         <div>
//           <p className="font-semibold">User ID</p>
//           <p className="font-light pt-2">{userData.userId || "N/A"}</p>
//         </div>
//         <div>
//           <p className="font-semibold">USER NAME</p>
//           <p className="font-light pt-2">{userData.name || "N/A"}</p>
//         </div>
//         <div>
//           <p className="font-semibold">CREATE DATE</p>
//           <p className="font-light pt-2">
//             {userData.createdAt
//               ? new Date(userData.createdAt).toLocaleDateString()
//               : "N/A"}
//           </p>
//         </div>
//         <div>
//           <p className="font-semibold">ROLE</p>
//           <p className="font-light pt-2">
//             {Array.isArray(userData.role)
//               ? userData.role
//                   .map((role) =>
//                     role
//                       .replace(/_/g, " ")
//                       .split(" ")
//                       .map(
//                         (word) =>
//                           word.charAt(0).toUpperCase() +
//                           word.slice(1).toLowerCase(),
//                       )
//                       .join(" "),
//                   )
//                   .join(", ")
//               : userData.role
//                 ? userData.role
//                     .replace(/_/g, " ")
//                     .split(" ")
//                     .map(
//                       (word) =>
//                         word.charAt(0).toUpperCase() +
//                         word.slice(1).toLowerCase(),
//                     )
//                     .join(" ")
//                 : "N/A"}
//           </p>
//         </div>
//         <div>
//           <p className="font-semibold">GROUP</p>
//           <p className="font-light pt-2">{userData.group || "N/A"}</p>
//         </div>
//         <div>
//           <p className="font-semibold">Organization</p>
//           <p className="font-light pt-2">{userData.organization || "N/A"}</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserDetails;

import React, { useEffect, useState } from "react";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllDepartments,
  fetchAllLocations,
} from "../../../../../redux/OrganizationSetup/organizationSetupSlice";
import dayjs from "dayjs";

const UserDetails = ({ onUserDataReceived }) => {
  const [userData, setUserData] = useState({});
  const [fetchedGroupName, setFetchedGroupName] = useState("");
  const token = useSelector((state) => state.auth.authToken);
  const location = useLocation();
  const { userId } = location.state || {};
  const user = useSelector((state) => state.auth.user);

  const dispatch = useDispatch();
  const { locationList, departmentList } = useSelector(
    (state) => state.orgSetup || {},
  );

  const fetchDetails = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_PROJECTS_BY_USER_ID(userId),
        token: token,
      });
      if (response.success) {
        const data = response.data[0];
        onUserDataReceived?.(data);
        setUserData(data);
      }
    } catch (error) {
      console.log("Unable to get user details", error);
    }
  };

  const fetchGroupName = async () => {
    try {
      const response = await getApi({
        apiUrl: "/api/client/dashboard/group/members",
        token: token,
      });
      if (response?.success && response?.data?.groupName) {
        setFetchedGroupName(response.data.groupName);
      }
    } catch (error) {
      console.log("Unable to fetch group data", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchDetails();
      fetchGroupName();
    }
  }, [token]);

  useEffect(() => {
    dispatch(fetchAllLocations());
    dispatch(fetchAllDepartments());
  }, [dispatch]);

  const formatRole = (roleData) => {
    if (!roleData) return "N/A";
    const roles = Array.isArray(roleData) ? roleData : [roleData];
    return roles
      .map((role) =>
        role
          .replace(/_/g, " ")
          .split(" ")
          .map(
            (word) =>
              word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
          )
          .join(" "),
      )
      .join(", ");
  };

  const getLocationName = () => {
    if (!userData) return "N/A";
    const locId =
      userData?.locationId?._id ||
      userData?.locationId ||
      userData?.location?._id ||
      userData?.location;
    if (!locId) return "N/A";
    const foundLoc = (locationList || []).find((l) => l._id === locId);
    return (
      foundLoc?.location_name ||
      foundLoc?.name ||
      userData?.locationId?.name ||
      locId
    );
  };

  const getDepartmentName = () => {
    if (!userData) return "N/A";
    const deptId =
      userData?.departmentId?._id ||
      userData?.departmentId ||
      userData?.department?._id ||
      userData?.department;
    if (!deptId) return "N/A";
    const foundDept = (departmentList || []).find((d) => d._id === deptId);
    return (
      foundDept?.department_name ||
      foundDept?.name ||
      userData?.departmentId?.name ||
      deptId
    );
  };

  const fields = [
    {
      label: "USER ID",
      value: userData?.employee_id || userData?.userId || "N/A",
    },
    { label: "USER NAME", value: userData?.email || userData?.name || "N/A" },
    {
      label: "CREATE DATE",
      value: userData?.createdAt
        ? dayjs(userData.createdAt).format("DD MMM YYYY")
        : "N/A",
    },
    { label: "ROLE", value: formatRole(userData?.role) },
    {
      label: "LOCATION",
      value: getLocationName(),
    },
    {
      label: "DEPARTMENT",
      value: getDepartmentName(),
    },
    { label: "GROUP", value: fetchedGroupName || userData?.group || "N/A" },
    {
      label: "ORGANIZATION",
      value: user?.organizationName || userData?.client?.name || "N/A",
    },
  ];

  return (
    <div className="bg-white p-6 sm:p-8 rounded-[10px]">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-8">
        {fields.map(({ label, value }, index) => (
          <div
            key={index}
            className="flex flex-col text-left text-sm md:text-base"
          >
            <p className="font-bold text-[#35424a] text-xs uppercase tracking-wide mb-1.5">
              {label}
            </p>
            <p className="font-normal text-gray-800 text-[15px] break-words">
              {value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserDetails;
